export default "__VITE_ASSET__DHuMFS4Y__"